import React from "react";
import { motion } from "framer-motion";
import Navbar from "../../components/Navbar";
import "./templateForm.css";

const TempalateForm = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <div className="flex-grow flex items-center justify-center px-6 py-8">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="rounded-2xl shadow-xl w-full max-w-md"
          style={{
            background: "linear-gradient(135deg, #fefaf6 0%, #e4d6c8 100%)",
            padding: "2rem",
          }}
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default TempalateForm;
